(function () {
  "use strict";

  var REGISTER_ENDPOINT = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/registerMobilePushToken";
  var MOBILE_SESSION_ENDPOINT = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/mobileSessionStart";
  var MOBILE_ACCOUNT_ENDPOINT = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/mobileAccountBootstrap";
  var MOBILE_CUSTOMER_ACCOUNT_ENDPOINT = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/mobileCustomerAccountSession";
  var INSTALLATION_KEY = "florame_native_installation_id";
  var PUSH_PROMPT_KEY = "florame_native_push_prompted_v1";
  var TOKEN_KEY = "florame_native_push_token";
  var TOKEN_HASH_KEY = "florame_native_push_token_hash";
  var ACCOUNT_KEY = "florame_native_account_v1";
  var CUSTOMER_ACCOUNT_TOKENS_KEY = "florame_customer_account_tokens_v1";
  var CUSTOMER_ACCOUNT_PKCE_KEY = "florame_customer_account_pkce_v1";
  var CUSTOMER_ACCOUNT_DISCOVERY_KEY = "florame_customer_account_discovery_v1";
  var DEFAULT_CUSTOMER_ACCOUNT_CLIENT_ID = "";
  var DEFAULT_CUSTOMER_ACCOUNT_SHOP_DOMAIN = "florame.ai";
  var DEFAULT_CUSTOMER_ACCOUNT_REDIRECT_URI = "shop.88783323459.app://callback";
  var DEFAULT_CUSTOMER_ACCOUNT_SCOPE = "openid email customer-account-api:full";
  var DEFAULT_CHANNEL_ID = "florame_updates";
  var watchSeq = 0;
  var watches = {};
  var MOBILE_TEXT_EN = {
    "Aggiornamenti Florame": "Florame updates",
    "Notifiche sugli ordini e aggiornamenti Florame": "Order notifications and Florame updates",
    "Account Florame": "Florame account",
    "Accedi a Florame": "Sign in to Florame",
    "Sessione app attiva": "App session active",
    "Caricamento account...": "Loading account...",
    "Usa il login social nativo dell'app.": "Use the app's native social login.",
    "Usa il login sicuro Shopify dell'app.": "Use the app's secure Shopify login.",
    "Apertura login...": "Opening login...",
    "Completa il login nella finestra sicura.": "Complete sign-in in the secure window.",
    "Login nativo non disponibile in questa build.": "Native login is not available in this build.",
    "Login Shopify non configurato in questa build.": "Shopify login is not configured in this build.",
    "Cliente": "Customer",
    "Ordini recenti": "Recent orders",
    "Nessun ordine recente": "No recent orders",
    "Profilo Shopify collegato": "Linked Shopify profile",
    "Home": "Home",
    "Esci": "Log out",
    "Profilo app": "App profile",
    "Uscita...": "Signing out...",
    "Uscita non completata.": "Sign out was not completed.",
    "Continua con Google": "Continue with Google",
    "Continua con Apple": "Continue with Apple",
    "Usa email": "Use email",
    "Chiudi": "Close",
    "Apertura Apple...": "Opening Apple...",
    "Apertura Google...": "Opening Google...",
    "Accesso completato.": "Signed in.",
    "Google non si e aperto. Riprova.": "Google did not open. Try again.",
    "Accesso non completato. Riprova.": "Sign in was not completed. Try again."
  };

  function getCapacitor() {
    return window.Capacitor || null;
  }

  function getNativeLanguage() {
    try {
      if (window.FlorameI18n && typeof window.FlorameI18n.getLanguage === "function") {
        var current = window.FlorameI18n.getLanguage();
        if (current === "en" || current === "it") return current;
      }
    } catch (_) {}
    try {
      var params = new URLSearchParams(window.location.search || "");
      var query = String(params.get("lang") || params.get("locale") || params.get("language") || "").slice(0, 2).toLowerCase();
      if (query === "en" || query === "it") return query;
    } catch (_) {}
    try {
      var stored = window.localStorage.getItem("florame_native_lang") || window.localStorage.getItem("bouquetLanguage") || "";
      stored = String(stored || "").slice(0, 2).toLowerCase();
      if (stored === "en" || stored === "it") return stored;
    } catch (_) {}
    try {
      var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      for (var i = 0; i < langs.length; i += 1) {
        var lang = String(langs[i] || "").slice(0, 2).toLowerCase();
        if (lang === "en" || lang === "it") return lang;
      }
    } catch (_) {}
    return "it";
  }

  function mnT(value) {
    var text = String(value == null ? "" : value);
    return getNativeLanguage() === "en" ? (MOBILE_TEXT_EN[text] || text) : text;
  }

  function isNativePlatform() {
    var cap = getCapacitor();
    try {
      return !!(cap && typeof cap.isNativePlatform === "function" && cap.isNativePlatform());
    } catch (_) {
      return false;
    }
  }

  function getPlugin(name) {
    var cap = getCapacitor();
    return cap && cap.Plugins ? cap.Plugins[name] : null;
  }

  function getPlatform() {
    var cap = getCapacitor();
    try {
      return cap && typeof cap.getPlatform === "function" ? cap.getPlatform() : "web";
    } catch (_) {
      return "web";
    }
  }

  function emit(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (_) {}
  }

  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "florame-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  async function prefGet(key) {
    var Preferences = getPlugin("Preferences");
    if (Preferences && typeof Preferences.get === "function") {
      var result = await Preferences.get({ key: key });
      return result && result.value ? result.value : "";
    }
    try {
      return window.localStorage.getItem(key) || "";
    } catch (_) {
      return "";
    }
  }

  async function prefSet(key, value) {
    var Preferences = getPlugin("Preferences");
    if (Preferences && typeof Preferences.set === "function") {
      await Preferences.set({ key: key, value: String(value || "") });
      return;
    }
    try {
      window.localStorage.setItem(key, String(value || ""));
    } catch (_) {}
  }

  async function prefRemove(key) {
    var Preferences = getPlugin("Preferences");
    if (Preferences && typeof Preferences.remove === "function") {
      await Preferences.remove({ key: key });
      return;
    }
    try {
      window.localStorage.removeItem(key);
    } catch (_) {}
  }

  async function getInstallationId() {
    var id = await prefGet(INSTALLATION_KEY);
    if (id) return id;
    id = makeId();
    await prefSet(INSTALLATION_KEY, id);
    return id;
  }

  function firstString(values) {
    for (var i = 0; i < values.length; i += 1) {
      var value = values[i];
      if (value === null || value === undefined) continue;
      value = String(value).trim();
      if (value) return value;
    }
    return "";
  }

  function getCustomerAccountConfig() {
    var theme = window.__florameThemeConfig || {};
    var cfg = theme.customerAccountAuth || window.__florameCustomerAccountAuth || {};
    var region = firstString([cfg.regionCountry, theme.customerAccountRegionCountry, "IT"]).toUpperCase().slice(0, 2);
    return {
      clientId: firstString([cfg.clientId, theme.customerAccountClientId, DEFAULT_CUSTOMER_ACCOUNT_CLIENT_ID]),
      shopDomain: firstString([cfg.shopDomain, theme.customerAccountShopDomain, DEFAULT_CUSTOMER_ACCOUNT_SHOP_DOMAIN]),
      redirectUri: firstString([cfg.redirectUri, theme.customerAccountRedirectUri, DEFAULT_CUSTOMER_ACCOUNT_REDIRECT_URI]),
      scope: firstString([cfg.scope, theme.customerAccountScope, DEFAULT_CUSTOMER_ACCOUNT_SCOPE]),
      regionCountry: region || "IT"
    };
  }

  function hasValidCustomerAccountClientId(clientId) {
    return /^shp_[A-Za-z0-9_-]{8,}$/.test(String(clientId || "").trim());
  }

  function customerAccountAuthAvailable() {
    if (!isNativePlatform()) return false;
    var cfg = getCustomerAccountConfig();
    return !!(hasValidCustomerAccountClientId(cfg.clientId) && cfg.shopDomain && cfg.redirectUri);
  }

  function customerAccountBrowserFallbackAvailable() {
    return !!(isNativePlatform() && getPlugin("Browser"));
  }

  function usesShopifyAccountLogin() {
    return customerAccountAuthAvailable();
  }

  function isCustomerAccountCallbackUrl(url) {
    if (!url) return false;
    try {
      var cfg = getCustomerAccountConfig();
      var parsed = new URL(url);
      var scheme = cfg.redirectUri.split("://")[0] || "";
      if (!scheme || parsed.protocol !== scheme + ":") return false;
      return parsed.hostname === "callback" || parsed.pathname === "/callback" || parsed.href.indexOf("code=") !== -1;
    } catch (_) {
      return false;
    }
  }

  function isCustomerAccountUrl(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.href);
      var host = String(parsed.hostname || "").toLowerCase();
      var path = String(parsed.pathname || "");
      if (host === "account.florame.ai") return true;
      if ((host === "florame.ai" || host.endsWith(".florame.ai") || host.endsWith(".myshopify.com")) && path.indexOf("/account") === 0) return true;
      return false;
    } catch (_) {
      return false;
    }
  }

  function getCustomerAccountBrowserUrl(url) {
    var cfg = getCustomerAccountConfig();
    var accountHost = "account." + (cfg.shopDomain || DEFAULT_CUSTOMER_ACCOUNT_SHOP_DOMAIN).replace(/^www\./, "");
    try {
      var parsed = new URL(url || "", window.location.href);
      var host = String(parsed.hostname || "").toLowerCase();
      if (host === accountHost || host === "account.florame.ai") return parsed.href;
      if (parsed.pathname && parsed.pathname.indexOf("/account") === 0) {
        return "https://" + accountHost + parsed.pathname + parsed.search + parsed.hash;
      }
    } catch (_) {}
    return "https://" + accountHost + "/";
  }

  function safeLocalStorage(key) {
    try {
      return window.localStorage.getItem(key) || "";
    } catch (_) {
      return "";
    }
  }

  function getCustomerContext() {
    var analyticsCustomer =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.customerId;
    var customer = window.__loggedCustomer || window.customer || {};
    return {
      customerId: firstString([
        customer.id,
        customer.customerId,
        window.HOMEPAGE_INIT_CUSTOMER_ID,
        analyticsCustomer,
        safeLocalStorage("florame_customer_id")
      ]),
      customerEmail: firstString([
        customer.email,
        customer.customerEmail,
        window.HOMEPAGE_INIT_CUSTOMER_EMAIL,
        safeLocalStorage("florame_customer_email")
      ])
    };
  }

  async function getDeviceContext() {
    var Device = getPlugin("Device");
    var out = {};
    if (!Device) return out;
    try {
      if (typeof Device.getInfo === "function") out.info = await Device.getInfo();
    } catch (_) {}
    try {
      if (typeof Device.getId === "function") out.id = await Device.getId();
    } catch (_) {}
    try {
      if (typeof Device.getLanguageTag === "function") out.languageTag = await Device.getLanguageTag();
    } catch (_) {}
    return out;
  }

  async function postJson(url, payload, options) {
    options = options || {};
    var headers = {
      "Accept": "application/json",
      "Content-Type": "application/json"
    };
    if (options.authorization) headers.Authorization = options.authorization;
    var response = await fetch(url, {
      method: "POST",
      headers: headers,
      credentials: "omit",
      body: JSON.stringify(payload || {})
    });
    var data = null;
    try {
      data = await response.json();
    } catch (_) {}
    if (!response.ok || (data && data.success === false)) {
      var error = new Error((data && (data.error || data.message)) || ("HTTP " + response.status));
      error.status = response.status;
      error.response = data;
      throw error;
    }
    return data || { success: true };
  }

  function bytesToBase64Url(bytes) {
    var binary = "";
    for (var i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }

  function randomBase64Url(byteLength) {
    var bytes = new Uint8Array(byteLength || 32);
    if (!window.crypto || typeof window.crypto.getRandomValues !== "function") {
      throw new Error("Secure random is not available");
    }
    window.crypto.getRandomValues(bytes);
    return bytesToBase64Url(bytes);
  }

  async function sha256Base64Url(value) {
    if (!window.crypto || !window.crypto.subtle || typeof window.crypto.subtle.digest !== "function") {
      throw new Error("PKCE digest is not available");
    }
    var bytes = new TextEncoder().encode(String(value || ""));
    var digest = await window.crypto.subtle.digest("SHA-256", bytes);
    return bytesToBase64Url(new Uint8Array(digest));
  }

  function decodeJwtPayload(token) {
    try {
      var part = String(token || "").split(".")[1] || "";
      if (!part) return {};
      part = part.replace(/-/g, "+").replace(/_/g, "/");
      while (part.length % 4) part += "=";
      return JSON.parse(atob(part));
    } catch (_) {
      return {};
    }
  }

  async function discoverCustomerAccountAuth() {
    var cached = await prefGet(CUSTOMER_ACCOUNT_DISCOVERY_KEY);
    if (cached) {
      try {
        var parsed = JSON.parse(cached);
        if (parsed && parsed.authorization_endpoint && parsed.token_endpoint && parsed.cachedAt && (Date.now() - parsed.cachedAt) < 24 * 60 * 60 * 1000) {
          return parsed;
        }
      } catch (_) {}
    }

    var cfg = getCustomerAccountConfig();
    var response = await fetch("https://" + cfg.shopDomain + "/.well-known/openid-configuration", {
      method: "GET",
      credentials: "omit",
      headers: { "Accept": "application/json" }
    });
    if (!response.ok) throw new Error("Customer account discovery failed");
    var data = await response.json();
    data.cachedAt = Date.now();
    await prefSet(CUSTOMER_ACCOUNT_DISCOVERY_KEY, JSON.stringify(data));
    return data;
  }

  async function loadCustomerAccountTokens(options) {
    options = options || {};
    var raw = await prefGet(CUSTOMER_ACCOUNT_TOKENS_KEY);
    if (!raw) return null;
    var tokens = null;
    try {
      tokens = JSON.parse(raw);
    } catch (_) {
      await prefRemove(CUSTOMER_ACCOUNT_TOKENS_KEY);
      return null;
    }
    if (!tokens || !tokens.accessToken) return null;
    var expiresAt = Number(tokens.expiresAt || 0);
    if (options.refresh !== false && tokens.refreshToken && expiresAt && Date.now() > expiresAt - 120000) {
      return refreshCustomerAccountTokens(tokens);
    }
    return tokens;
  }

  async function saveCustomerAccountTokens(tokenResponse) {
    var expiresIn = Math.max(60, Number(tokenResponse.expires_in || tokenResponse.expiresIn || 3600));
    var tokens = {
      accessToken: firstString([tokenResponse.access_token, tokenResponse.accessToken]),
      refreshToken: firstString([tokenResponse.refresh_token, tokenResponse.refreshToken]),
      idToken: firstString([tokenResponse.id_token, tokenResponse.idToken]),
      tokenType: firstString([tokenResponse.token_type, tokenResponse.tokenType, "Bearer"]),
      expiresAt: Date.now() + Math.max(60, expiresIn - 60) * 1000,
      savedAt: Date.now()
    };
    if (!tokens.accessToken) throw new Error("Customer account token missing");
    await prefSet(CUSTOMER_ACCOUNT_TOKENS_KEY, JSON.stringify(tokens));
    return tokens;
  }

  async function clearCustomerAccountState() {
    await prefRemove(CUSTOMER_ACCOUNT_TOKENS_KEY);
    await prefRemove(CUSTOMER_ACCOUNT_PKCE_KEY);
  }

  async function requestCustomerAccountToken(params) {
    var cfg = getCustomerAccountConfig();
    var discovery = await discoverCustomerAccountAuth();
    var body = new URLSearchParams();
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== "") body.set(key, params[key]);
    });
    body.set("client_id", cfg.clientId);

    var response = await fetch(discovery.token_endpoint, {
      method: "POST",
      credentials: "omit",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: body.toString()
    });
    var data = null;
    try {
      data = await response.json();
    } catch (_) {}
    if (!response.ok || (data && data.error)) {
      throw new Error((data && (data.error_description || data.error)) || ("Token exchange failed: " + response.status));
    }
    return saveCustomerAccountTokens(data || {});
  }

  async function refreshCustomerAccountTokens(tokens) {
    if (!tokens || !tokens.refreshToken) return null;
    try {
      return await requestCustomerAccountToken({
        grant_type: "refresh_token",
        refresh_token: tokens.refreshToken
      });
    } catch (error) {
      await clearCustomerAccountState();
      throw error;
    }
  }

  async function postCustomerAccountSession(tokens, source) {
    if (!tokens || !tokens.accessToken) throw new Error("Customer account access token missing");
    var idClaims = decodeJwtPayload(tokens.idToken);
    var data = await postJson(MOBILE_CUSTOMER_ACCOUNT_ENDPOINT, {
      appId: "ai.florame.app",
      platform: getPlatform(),
      url: window.location.href,
      userAgent: navigator.userAgent || "",
      source: source || "customer_account",
      idToken: tokens.idToken || "",
      idTokenClaims: {
        email: firstString([idClaims.email]),
        emailVerified: idClaims.email_verified === true,
        subject: firstString([idClaims.sub]),
        issuer: firstString([idClaims.iss]),
        audience: firstString([idClaims.aud])
      }
    }, {
      authorization: "Bearer " + tokens.accessToken
    });
    if (data && data.account) await saveNativeAccount(data.account);
    return data && data.account ? data.account : null;
  }

  async function bootstrapShopifyCustomerAccount() {
    var tokens = await loadCustomerAccountTokens({ refresh: true });
    if (!tokens) return loadNativeAccount();
    return postCustomerAccountSession(tokens, "customer_account_bootstrap");
  }

  async function startShopifyCustomerAccountLogin() {
    if (!customerAccountAuthAvailable()) throw new Error("Shopify customer account login is not configured");
    var cfg = getCustomerAccountConfig();
    var discovery = await discoverCustomerAccountAuth();
    var verifier = randomBase64Url(48);
    var state = randomBase64Url(24);
    var nonce = randomBase64Url(24);
    var challenge = await sha256Base64Url(verifier);
    var authUrl = new URL(discovery.authorization_endpoint);
    authUrl.searchParams.set("scope", cfg.scope);
    authUrl.searchParams.set("client_id", cfg.clientId);
    authUrl.searchParams.set("response_type", "code");
    authUrl.searchParams.set("redirect_uri", cfg.redirectUri);
    authUrl.searchParams.set("state", state);
    authUrl.searchParams.set("nonce", nonce);
    authUrl.searchParams.set("code_challenge", challenge);
    authUrl.searchParams.set("code_challenge_method", "S256");
    authUrl.searchParams.set("locale", getNativeLanguage());
    authUrl.searchParams.set("region_country", cfg.regionCountry);

    await prefSet(CUSTOMER_ACCOUNT_PKCE_KEY, JSON.stringify({
      state: state,
      nonce: nonce,
      verifier: verifier,
      redirectUri: cfg.redirectUri,
      createdAt: Date.now()
    }));
    emit("florame:native-auth", { status: "pending", provider: "shopify_customer_account" });
    await openExternal(authUrl.toString());
    return null;
  }

  async function startShopifyAccountBrowserLogin(url) {
    if (!customerAccountBrowserFallbackAvailable()) throw new Error("Shopify browser login is not available");
    await clearCustomerAccountState();
    emit("florame:native-auth", { status: "pending", provider: "shopify_customer_account_browser" });
    await openExternal(getCustomerAccountBrowserUrl(url || window.location.href));
    return null;
  }

  async function handleCustomerAccountCallback(url) {
    if (!isCustomerAccountCallbackUrl(url)) return false;
    var Browser = getPlugin("Browser");
    try {
      if (Browser && typeof Browser.close === "function") await Browser.close();
    } catch (_) {}

    var parsed = new URL(url);
    var error = parsed.searchParams.get("error");
    if (error) {
      await prefRemove(CUSTOMER_ACCOUNT_PKCE_KEY);
      throw new Error(parsed.searchParams.get("error_description") || error);
    }
    var code = parsed.searchParams.get("code") || "";
    var state = parsed.searchParams.get("state") || "";
    var raw = await prefGet(CUSTOMER_ACCOUNT_PKCE_KEY);
    var pkce = {};
    try {
      pkce = raw ? JSON.parse(raw) : {};
    } catch (_) {}
    if (!code || !state || !pkce.state || state !== pkce.state) {
      await prefRemove(CUSTOMER_ACCOUNT_PKCE_KEY);
      throw new Error("Invalid customer account state");
    }
    if (pkce.createdAt && (Date.now() - Number(pkce.createdAt)) > 15 * 60 * 1000) {
      await prefRemove(CUSTOMER_ACCOUNT_PKCE_KEY);
      throw new Error("Customer account login expired");
    }

    var tokens = await requestCustomerAccountToken({
      grant_type: "authorization_code",
      redirect_uri: pkce.redirectUri || getCustomerAccountConfig().redirectUri,
      code: code,
      code_verifier: pkce.verifier
    });
    await prefRemove(CUSTOMER_ACCOUNT_PKCE_KEY);
    await postCustomerAccountSession(tokens, "customer_account_callback");
    await refreshTokenIfAllowed();
    return true;
  }

  function getFirebaseAuthentication() {
    return getPlugin("FirebaseAuthentication");
  }

  function getFlorameGoogleAuth() {
    return getPlugin("FlorameGoogleAuth");
  }

  function nativeAuthAvailable(provider) {
    var FirebaseAuthentication = getFirebaseAuthentication();
    var canReadFirebaseToken = !!(FirebaseAuthentication && typeof FirebaseAuthentication.getIdToken === "function");
    var FlorameGoogleAuth = getFlorameGoogleAuth();
    var hasFlorameGoogle = !!(FlorameGoogleAuth && typeof FlorameGoogleAuth.signInWithGoogle === "function");
    if (provider === "google.com") {
      return canReadFirebaseToken && (hasFlorameGoogle || typeof FirebaseAuthentication.signInWithGoogle === "function");
    }
    if (!canReadFirebaseToken) return customerAccountAuthAvailable();
    if (provider === "apple.com") return typeof FirebaseAuthentication.signInWithApple === "function";
    return hasFlorameGoogle ||
      typeof FirebaseAuthentication.signInWithGoogle === "function" ||
      typeof FirebaseAuthentication.signInWithApple === "function" ||
      customerAccountAuthAvailable();
  }

  function normalizeNativeAuthUser(result) {
    var user = result && result.user ? result.user : result;
    user = user || {};
    var providers = [];
    if (Array.isArray(user.providerData)) {
      providers = user.providerData.map(function (provider) {
        return provider && provider.providerId ? provider.providerId : "";
      }).filter(Boolean);
    }
    if (user.providerId && providers.indexOf(user.providerId) === -1) providers.unshift(user.providerId);
    return {
      uid: firstString([user.uid]),
      email: firstString([user.email]),
      emailVerified: user.emailVerified === true,
      displayName: firstString([user.displayName]),
      photoUrl: firstString([user.photoUrl, user.photoURL]),
      providerId: firstString([user.providerId, providers[0]]),
      providers: providers
    };
  }

  function applyNativeAccountContext(account) {
    if (!account || typeof account !== "object") return;
    var shopify = account.shopifyCustomer || {};
    var customerId = firstString([shopify.id, account.shopifyCustomerId]);
    var customerEmail = firstString([shopify.email, account.email, account.shopifyCustomerEmail]);
    try {
      window.__loggedCustomer = Object.assign({}, window.__loggedCustomer || {}, {
        id: customerId || null,
        email: customerEmail || null,
        nativeApp: true,
        uid: firstString([account.uid])
      });
    } catch (_) {}
    try {
      window.localStorage.setItem("florame_native_signed_in", "1");
      if (customerId) {
        window.localStorage.setItem("florame_customer_id", customerId);
        window.localStorage.setItem("florame_native_shopify_customer_id", customerId);
      }
      if (customerEmail) {
        window.localStorage.setItem("florame_customer_email", customerEmail);
        window.localStorage.setItem("florame_native_customer_email", customerEmail);
      }
    } catch (_) {}
    try {
      document.documentElement.setAttribute("data-florame-native-signed-in", "true");
      if (customerId) document.documentElement.setAttribute("data-florame-native-shopify-customer", customerId);
    } catch (_) {}
    emit("florame:native-account-context", {
      signedIn: true,
      customerId: customerId,
      customerEmail: customerEmail,
      account: account
    });
  }

  function clearNativeAccountContext() {
    try {
      if (window.__loggedCustomer && window.__loggedCustomer.nativeApp) {
        window.__loggedCustomer = { id: null, email: null, nativeApp: false };
      }
    } catch (_) {}
    try {
      window.localStorage.removeItem("florame_native_signed_in");
      window.localStorage.removeItem("florame_native_shopify_customer_id");
      window.localStorage.removeItem("florame_native_customer_email");
    } catch (_) {}
    try {
      document.documentElement.removeAttribute("data-florame-native-signed-in");
      document.documentElement.removeAttribute("data-florame-native-shopify-customer");
    } catch (_) {}
  }

  async function nativeAuthGetIdToken(forceRefresh) {
    var FirebaseAuthentication = getFirebaseAuthentication();
    if (!FirebaseAuthentication || typeof FirebaseAuthentication.getIdToken !== "function") return "";
    try {
      if (typeof FirebaseAuthentication.getCurrentUser === "function") {
        var current = await FirebaseAuthentication.getCurrentUser();
        if (!current || !current.user) return "";
      }
    } catch (_) {}
    var result = await FirebaseAuthentication.getIdToken({ forceRefresh: forceRefresh === true });
    return result && result.token ? String(result.token) : "";
  }

  async function saveNativeAccount(account) {
    if (!account) return;
    applyNativeAccountContext(account);
    await prefSet(ACCOUNT_KEY, JSON.stringify({
      account: account,
      savedAt: Date.now()
    }));
    emit("florame:native-auth", { status: "signed_in", account: account });
  }

  async function loadNativeAccount() {
    var raw = await prefGet(ACCOUNT_KEY);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      var account = parsed && parsed.account ? parsed.account : null;
      if (account) applyNativeAccountContext(account);
      return account;
    } catch (_) {
      return null;
    }
  }

  async function postNativeAccount(endpoint, payload, forceRefresh) {
    var idToken = await nativeAuthGetIdToken(forceRefresh === true);
    if (!idToken) throw new Error("Native auth token not available");
    var data = await postJson(endpoint, Object.assign({
      appId: "ai.florame.app",
      platform: getPlatform(),
      url: window.location.href,
      userAgent: navigator.userAgent || ""
    }, payload || {}), {
      authorization: "Bearer " + idToken
    });
    if (data && data.account) await saveNativeAccount(data.account);
    return data && data.account ? data.account : null;
  }

  function withAndroidGoogleOpenTimeout(promise) {
    if (getPlatform() !== "android") return promise;
    var sawHidden = document.visibilityState === "hidden";
    var settled = false;
    var initialTimer = null;
    var returnTimer = null;
    var rejectPending = null;
    var cleanup = function () {
      if (initialTimer) window.clearTimeout(initialTimer);
      if (returnTimer) window.clearTimeout(returnTimer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    var onVisibilityChange = function () {
      if (document.visibilityState === "hidden") {
        sawHidden = true;
        return;
      }
      if (!settled && sawHidden && !returnTimer) {
        returnTimer = window.setTimeout(function () {
          if (!settled) {
            settled = true;
            cleanup();
            if (rejectPending) rejectPending(new Error("Google sign-in did not finish"));
          }
        }, 90000);
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return new Promise(function (resolve, reject) {
      rejectPending = reject;
      initialTimer = window.setTimeout(function () {
        if (!settled && !sawHidden && document.visibilityState !== "hidden") {
          settled = true;
          cleanup();
          reject(new Error("Google sign-in did not open"));
        }
      }, 10000);
      promise.then(function (value) {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(value);
      }).catch(function (err) {
        if (settled) return;
        settled = true;
        cleanup();
        reject(err);
      });
    });
  }

  async function startNativeSocialLogin(provider) {
    provider = provider === "apple.com" ? "apple.com" : "google.com";
    var FirebaseAuthentication = getFirebaseAuthentication();
    if (!nativeAuthAvailable(provider)) {
      throw new Error("Native Firebase auth not available in this build");
    }
    try {
      if (FirebaseAuthentication && typeof FirebaseAuthentication.setLanguageCode === "function") {
        await FirebaseAuthentication.setLanguageCode({ languageCode: (navigator.language || "it-IT") });
      }
    } catch (_) {}
    var result;
    if (provider === "apple.com") {
      result = await FirebaseAuthentication.signInWithApple();
    } else {
      var FlorameGoogleAuth = getFlorameGoogleAuth();
      result = FlorameGoogleAuth && typeof FlorameGoogleAuth.signInWithGoogle === "function"
        ? await withAndroidGoogleOpenTimeout(FlorameGoogleAuth.signInWithGoogle())
        : await withAndroidGoogleOpenTimeout(FirebaseAuthentication.signInWithGoogle(
          getPlatform() === "android" ? { useCredentialManager: false } : undefined
        ));
    }
    var user = normalizeNativeAuthUser(result);
    var account = await postNativeAccount(MOBILE_SESSION_ENDPOINT, {
      provider: provider,
      user: user,
      source: "native_social_login"
    }, true);
    await refreshTokenIfAllowed();
    return account || user;
  }

  async function bootstrapNativeAccount() {
    if (customerAccountAuthAvailable()) {
      try {
        var account = await bootstrapShopifyCustomerAccount();
        if (account) return account;
      } catch (_) {}
    }
    if (!nativeAuthAvailable()) return loadNativeAccount();
    var FirebaseAuthentication = getFirebaseAuthentication();
    try {
      if (FirebaseAuthentication && typeof FirebaseAuthentication.getCurrentUser === "function") {
        var current = await FirebaseAuthentication.getCurrentUser();
        if (!current || !current.user) {
          await prefRemove(ACCOUNT_KEY);
          return null;
        }
      }
    } catch (_) {}
    try {
      return await postNativeAccount(MOBILE_ACCOUNT_ENDPOINT, {
        source: "native_account_bootstrap"
      }, false);
    } catch (_) {
      return loadNativeAccount();
    }
  }

  async function signOutNativeAccount() {
    var FirebaseAuthentication = getFirebaseAuthentication();
    if (FirebaseAuthentication && typeof FirebaseAuthentication.signOut === "function") {
      try {
        await FirebaseAuthentication.signOut();
      } catch (_) {}
    }
    await clearCustomerAccountState();
    await prefRemove(ACCOUNT_KEY);
    clearNativeAccountContext();
    emit("florame:native-auth", { status: "signed_out" });
  }

  async function registerPushToken(token, meta) {
    if (!token) throw new Error("Missing FCM token");
    var installationId = await getInstallationId();
    var device = await getDeviceContext();
    var customer = getCustomerContext();
    var info = device.info || {};
    var id = device.id || {};
    var language = device.languageTag && device.languageTag.value ? device.languageTag.value : (navigator.language || "");

    var payload = Object.assign({
      token: String(token),
      provider: "fcm",
      appId: "ai.florame.app",
      platform: getPlatform(),
      installationId: installationId,
      deviceId: id.identifier || "",
      deviceModel: info.model || "",
      deviceManufacturer: info.manufacturer || "",
      osVersion: info.osVersion || "",
      appVersion: info.appVersion || "",
      appBuild: info.appBuild || "",
      customerId: customer.customerId || "",
      customerEmail: customer.customerEmail || "",
      locale: language,
      url: window.location.href,
      userAgent: navigator.userAgent || "",
      source: "shopify_webview"
    }, meta || {});

    var authorization = "";
    try {
      var idToken = await nativeAuthGetIdToken(false);
      if (idToken) authorization = "Bearer " + idToken;
    } catch (_) {}
    try {
      var customerTokens = await loadCustomerAccountTokens({ refresh: true });
      if (customerTokens && customerTokens.accessToken) {
        payload.customerAccountAccessToken = customerTokens.accessToken;
        payload.customerAccountIdToken = customerTokens.idToken || "";
      }
    } catch (_) {}

    var result = await postJson(REGISTER_ENDPOINT, payload, {
      authorization: authorization
    });
    try {
      window.localStorage.setItem(TOKEN_KEY, String(token));
      if (result.tokenHash) window.localStorage.setItem(TOKEN_HASH_KEY, result.tokenHash);
    } catch (_) {}
    emit("florame:native-push-token", {
      token: token,
      tokenHash: result.tokenHash || "",
      platform: payload.platform,
      permission: payload.permission || ""
    });
    return result;
  }

  async function ensureNotificationChannel() {
    var FirebaseMessaging = getPlugin("FirebaseMessaging");
    if (getPlatform() !== "android" || !FirebaseMessaging || typeof FirebaseMessaging.createChannel !== "function") {
      return;
    }
    try {
      await FirebaseMessaging.createChannel({
        id: DEFAULT_CHANNEL_ID,
        name: mnT("Aggiornamenti Florame"),
        description: mnT("Notifiche sugli ordini e aggiornamenti Florame"),
        importance: 4,
        visibility: 1,
        vibration: true,
        lights: true,
        lightColor: "#ff4d75"
      });
    } catch (_) {}
  }

  function isGranted(state) {
    return state === "granted";
  }

  async function requestNotifications(options) {
    options = options || {};
    var FirebaseMessaging = getPlugin("FirebaseMessaging");
    if (!FirebaseMessaging) throw new Error("FirebaseMessaging plugin not available");
    if (typeof FirebaseMessaging.isSupported === "function") {
      var support = await FirebaseMessaging.isSupported();
      if (support && support.isSupported === false) throw new Error("FirebaseMessaging not supported");
    }

    var permission = await FirebaseMessaging.checkPermissions();
    var receive = permission && permission.receive;
    if (!isGranted(receive) && options.prompt !== false && typeof FirebaseMessaging.requestPermissions === "function") {
      permission = await FirebaseMessaging.requestPermissions();
      receive = permission && permission.receive;
    }

    if (!isGranted(receive)) {
      var denied = new Error("Notification permission not granted");
      denied.permission = receive || "denied";
      emit("florame:native-push-error", { error: denied.message, permission: denied.permission });
      throw denied;
    }

    await ensureNotificationChannel();
    var result = await FirebaseMessaging.getToken();
    if (result && result.token) {
      await registerPushToken(result.token, {
        permission: receive,
        source: options.source || "request"
      });
    }
    return { permission: receive, token: result && result.token ? result.token : "" };
  }

  function normalizePosition(position) {
    var coords = (position && position.coords) || {};
    return {
      coords: {
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
        altitude: coords.altitude == null ? null : coords.altitude,
        altitudeAccuracy: coords.altitudeAccuracy == null ? null : coords.altitudeAccuracy,
        heading: coords.heading == null ? null : coords.heading,
        speed: coords.speed == null ? null : coords.speed
      },
      timestamp: (position && position.timestamp) || Date.now()
    };
  }

  function toGeoError(error) {
    return {
      code: error && error.code ? error.code : 1,
      message: error && error.message ? error.message : String(error || "Location error")
    };
  }

  async function requestLocation(options) {
    options = Object.assign({
      enableHighAccuracy: true,
      timeout: 12000,
      maximumAge: 300000,
      enableLocationFallback: true
    }, options || {});
    var Geolocation = getPlugin("Geolocation");
    if (!Geolocation) throw new Error("Geolocation plugin not available");

    var status = null;
    try {
      status = await Geolocation.checkPermissions();
    } catch (_) {}
    var locationState = status && (status.location || status.coarseLocation);
    if (!isGranted(locationState) && options.prompt !== false && typeof Geolocation.requestPermissions === "function") {
      status = await Geolocation.requestPermissions({ permissions: ["location"] });
      locationState = status && (status.location || status.coarseLocation);
    }
    if (locationState === "denied") {
      throw new Error("Location permission denied");
    }

    var position = await Geolocation.getCurrentPosition(options);
    var normalized = normalizePosition(position);
    emit("florame:native-location", normalized);
    return normalized;
  }

  function patchGeolocation() {
    var Geolocation = getPlugin("Geolocation");
    if (!Geolocation || !navigator) return;
    var nativeGeolocation = {
      getCurrentPosition: function (success, error, options) {
        requestLocation(options)
          .then(function (position) {
            if (typeof success === "function") success(position);
          })
          .catch(function (err) {
            emit("florame:native-location-error", { error: err.message || String(err) });
            if (typeof error === "function") error(toGeoError(err));
          });
      },
      watchPosition: function (success, error, options) {
        var localId = "florame_watch_" + (++watchSeq);
        watches[localId] = { nativeId: "", pendingClear: false };
        Geolocation.watchPosition(options || {}, function (position, err) {
          if (err) {
            emit("florame:native-location-error", { error: err.message || String(err) });
            if (typeof error === "function") error(toGeoError(err));
            return;
          }
          if (position && typeof success === "function") success(normalizePosition(position));
        })
          .then(function (nativeId) {
            if (!watches[localId]) return;
            watches[localId].nativeId = nativeId;
            if (watches[localId].pendingClear) nativeGeolocation.clearWatch(localId);
          })
          .catch(function (err) {
            if (typeof error === "function") error(toGeoError(err));
          });
        return localId;
      },
      clearWatch: function (id) {
        var record = watches[id];
        if (!record) return;
        if (!record.nativeId) {
          record.pendingClear = true;
          return;
        }
        Geolocation.clearWatch({ id: record.nativeId }).catch(function () {});
        delete watches[id];
      }
    };

    try {
      Object.defineProperty(navigator, "geolocation", {
        configurable: true,
        value: nativeGeolocation
      });
    } catch (_) {
      try {
        navigator.geolocation = nativeGeolocation;
      } catch (_) {}
    }
  }

  function extractNotificationUrl(event) {
    var notification = event && event.notification ? event.notification : event;
    var data = notification && notification.data ? notification.data : {};
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (_) {
        data = {};
      }
    }
    return firstString([
      data.url,
      data.link,
      data.deepLink,
      notification && notification.link,
      notification && notification.clickAction
    ]);
  }

  function openExternal(url) {
    if (!url) return Promise.resolve(false);
    var Browser = getPlugin("Browser");
    if (Browser && typeof Browser.open === "function") {
      return Browser.open({ url: url }).then(function () { return true; });
    }
    window.location.href = url;
    return Promise.resolve(true);
  }

  function injectStyle(id, css) {
    if (document.getElementById(id)) return;
    var style = document.createElement("style");
    style.id = id;
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function isAccountLoginPage() {
    var path = window.location && window.location.pathname ? window.location.pathname : "";
    return path === "/account/login" || path === "/account" || path.indexOf("/account/login") === 0;
  }

  function getShopDomain() {
    return firstString([
      window.Shopify && window.Shopify.shop,
      "19e9d8-1e.myshopify.com"
    ]);
  }

  function hideOxiSocialIframe() {
    var nodes = document.querySelectorAll([
      ".oxi_social_wrapper",
      ".oxi-social-login",
      "#oxi-social-login",
      "iframe.social_login_frame",
      "iframe#social_login_frame"
    ].join(","));
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!node) continue;
      node.setAttribute("data-florame-ios-hidden", "true");
      node.style.setProperty("display", "none", "important");
      node.style.setProperty("height", "0", "important");
      node.style.setProperty("margin", "0", "important");
      node.style.setProperty("padding", "0", "important");
    }
  }

  function getAccountLoginForm() {
    return document.querySelector('form[action*="/account/login"], form[action$="/account"]');
  }

  function setIosClassicLoginFormHidden(hidden) {
    var form = getAccountLoginForm();
    if (!form) return;
    if (hidden) {
      form.setAttribute("data-florame-ios-native-hidden", "true");
      form.style.setProperty("display", "none", "important");
      return;
    }
    form.removeAttribute("data-florame-ios-native-hidden");
    form.style.removeProperty("display");
  }

  function accountDisplayName(account) {
    return firstString([
      account && account.displayName,
      account && account.shopifyCustomer && [account.shopifyCustomer.firstName, account.shopifyCustomer.lastName].filter(Boolean).join(" "),
      account && account.email,
      mnT("Account Florame")
    ]);
  }

  function accountShopifyLabel(account) {
    var shopify = account && account.shopifyCustomer ? account.shopifyCustomer : null;
    return shopify && shopify.id ? ("Shopify #" + shopify.id) : mnT("Profilo app");
  }

  function formatAccountOrder(order) {
    if (!order) return "";
    return firstString([
      [order.name || order.orderNumber, order.totalPrice && order.currency ? (order.totalPrice + " " + order.currency) : order.totalPrice].filter(Boolean).join(" · "),
      order.name,
      order.orderNumber
    ]);
  }

  function setIosNativePanelState(wrapper, state, account, message) {
    if (!wrapper) return;
    var title = wrapper.querySelector("[data-florame-ios-native-title]");
    var subtitle = wrapper.querySelector("[data-florame-ios-native-subtitle]");
    var status = wrapper.querySelector("[data-florame-ios-native-status]");
    var accountBox = wrapper.querySelector("[data-florame-ios-native-account]");
    var emailButton = wrapper.querySelector("[data-florame-ios-native-email]");
    var buttons = wrapper.querySelectorAll("[data-florame-ios-native-provider]");
    var signedIn = state === "signed_in";
    var loading = state === "loading";

    wrapper.setAttribute("data-florame-ios-native-state", state || "idle");
    wrapper.__florameIosNativeState = {
      state: state || "idle",
      account: account || null,
      message: message || ""
    };
    for (var i = 0; i < buttons.length; i += 1) {
      var provider = buttons[i].getAttribute("data-florame-ios-native-provider") || "";
      buttons[i].disabled = loading || !nativeAuthAvailable(provider);
      buttons[i].style.display = signedIn ? "none" : "";
    }
    if (emailButton) emailButton.style.display = signedIn ? "none" : "";

    if (title) title.textContent = signedIn
      ? (getNativeLanguage() === "en" ? "Hi " : "Ciao ") + accountDisplayName(account)
      : mnT("Accedi a Florame");
    if (subtitle) {
      subtitle.textContent = signedIn
        ? firstString([account && account.email, mnT("Sessione app attiva")])
        : mnT("Usa il login social nativo dell'app.");
    }
    if (status) {
      status.textContent = message ? mnT(message) : (loading
        ? mnT("Apertura login...")
        : (nativeAuthAvailable() ? "" : mnT(usesShopifyAccountLogin() ? "Login Shopify non configurato in questa build." : "Login nativo non disponibile in questa build.")));
    }
    if (accountBox) {
      if (signedIn) {
        var orders = Array.isArray(account && account.orders) ? account.orders : [];
        var shopify = account && account.shopifyCustomer ? account.shopifyCustomer : null;
        accountBox.style.display = "";
        accountBox.innerHTML = [
          '<div class="florame-ios-native-account-row"><span>Email</span><strong></strong></div>',
          '<div class="florame-ios-native-account-row"><span>' + mnT("Cliente") + '</span><strong></strong></div>',
          '<div class="florame-ios-native-account-row"><span>' + mnT("Ordini recenti") + '</span><strong></strong></div>',
          '<div class="florame-ios-native-actions">',
          '<button type="button" data-florame-ios-native-home>' + mnT("Home") + '</button>',
          '<button type="button" data-florame-ios-native-logout>' + mnT("Esci") + '</button>',
          '</div>'
        ].join("");
        var values = accountBox.querySelectorAll("strong");
        if (values[0]) values[0].textContent = firstString([account.email, "-"]);
        if (values[1]) values[1].textContent = accountShopifyLabel(account);
        if (values[2]) values[2].textContent = String(orders.length || 0);
        var home = accountBox.querySelector("[data-florame-ios-native-home]");
        var logout = accountBox.querySelector("[data-florame-ios-native-logout]");
        if (home) home.addEventListener("click", function () { window.location.href = "/pages/home"; });
        if (logout) {
          logout.addEventListener("click", function () {
            setIosNativePanelState(wrapper, "loading", null, "Uscita...");
            signOutNativeAccount().then(function () {
              setIosNativePanelState(wrapper, "idle", null, "");
              if (!nativeAuthAvailable()) setIosClassicLoginFormHidden(false);
            }).catch(function () {
              setIosNativePanelState(wrapper, "idle", null, "Uscita non completata.");
            });
          });
        }
      } else {
        accountBox.style.display = "none";
        accountBox.innerHTML = "";
      }
    }
  }

  function ensureIosNativeLoginPanel() {
    if (document.querySelector("[data-florame-ios-native-login]")) return;
    var form = getAccountLoginForm();
    var mount = form && form.parentNode ? form.parentNode : document.querySelector("main, #MainContent, .main-content, body");
    if (!mount) return;
    var platform = getPlatform();
    var showApple = platform === "ios";

    var wrapper = document.createElement("section");
    wrapper.className = "florame-ios-native-login";
    wrapper.setAttribute("data-florame-ios-native-login", "true");
    wrapper.innerHTML = [
      '<div class="florame-ios-native-logo">Florame</div>',
      '<h2 data-florame-ios-native-title>' + mnT("Accedi a Florame") + '</h2>',
      '<p data-florame-ios-native-subtitle>' + mnT("Usa il login social nativo dell'app.") + '</p>',
      '<div class="florame-ios-native-buttons">',
      '<button type="button" data-florame-ios-native-provider="google.com"><span class="florame-ios-native-mark">G</span><span>' + mnT("Continua con Google") + '</span></button>',
      showApple ? '<button type="button" data-florame-ios-native-provider="apple.com"><span class="florame-ios-native-mark">Apple</span><span>' + mnT("Continua con Apple") + '</span></button>' : '',
      '</div>',
      '<div class="florame-ios-native-status" data-florame-ios-native-status aria-live="polite"></div>',
      '<div class="florame-ios-native-account" data-florame-ios-native-account style="display:none"></div>',
      '<button type="button" class="florame-ios-native-email" data-florame-ios-native-email>' + mnT("Usa email") + '</button>'
    ].join("");

    if (form) {
      mount.insertBefore(wrapper, form);
    } else {
      mount.insertBefore(wrapper, mount.firstChild);
    }

    var providerButtons = wrapper.querySelectorAll("[data-florame-ios-native-provider]");
    for (var i = 0; i < providerButtons.length; i += 1) {
      providerButtons[i].addEventListener("click", function (event) {
        var provider = event.currentTarget.getAttribute("data-florame-ios-native-provider") || "google.com";
        setIosClassicLoginFormHidden(true);
        setIosNativePanelState(wrapper, "loading", null, provider === "apple.com" ? "Apertura Apple..." : "Apertura Google...");
        startNativeSocialLogin(provider)
          .then(function (account) {
            if (!account) {
              setIosNativePanelState(wrapper, "loading", null, "Completa il login nella finestra sicura.");
              return;
            }
            setIosClassicLoginFormHidden(true);
            setIosNativePanelState(wrapper, "signed_in", account, "Accesso completato.");
          })
          .catch(function (err) {
            emit("florame:native-auth-error", { error: err && err.message ? err.message : String(err), provider: provider });
            setIosNativePanelState(wrapper, "idle", null, "Accesso non completato. Riprova.");
          });
      });
    }

    var emailButton = wrapper.querySelector("[data-florame-ios-native-email]");
    if (emailButton) {
      emailButton.addEventListener("click", function () {
        setIosClassicLoginFormHidden(false);
      });
    }

    setIosClassicLoginFormHidden(nativeAuthAvailable());
    setIosNativePanelState(wrapper, "idle", null, "");
    bootstrapNativeAccount().then(function (account) {
      if (account && (account.uid || account.email)) {
        setIosClassicLoginFormHidden(true);
        setIosNativePanelState(wrapper, "signed_in", account, "");
      }
    }).catch(function () {});
  }

  window.addEventListener("florame:native-language-change", function () {
    var panels = document.querySelectorAll("[data-florame-ios-native-login]");
    for (var i = 0; i < panels.length; i += 1) {
      var snapshot = panels[i].__florameIosNativeState || { state: "idle", account: null, message: "" };
      setIosNativePanelState(panels[i], snapshot.state, snapshot.account, snapshot.message);
    }
  });

  window.addEventListener("florame:native-auth", function (event) {
    var detail = event && event.detail ? event.detail : {};
    var panels = document.querySelectorAll("[data-florame-ios-native-login]");
    for (var i = 0; i < panels.length; i += 1) {
      if (detail.status === "pending") {
        setIosClassicLoginFormHidden(true);
        setIosNativePanelState(panels[i], "loading", null, "Completa il login nella finestra sicura.");
      } else if (detail.status === "signed_in") {
        setIosClassicLoginFormHidden(true);
        setIosNativePanelState(panels[i], "signed_in", detail.account || null, "Accesso completato.");
      } else if (detail.status === "signed_out") {
        setIosNativePanelState(panels[i], "idle", null, "");
      }
    }
    var overlays = document.querySelectorAll("[data-florame-native-account-overlay]");
    for (var j = 0; j < overlays.length; j += 1) {
      if (detail.status === "pending") {
        setAccountOverlayState(overlays[j], "loading", null, "Completa il login nella finestra sicura.");
      } else if (detail.status === "signed_in") {
        setAccountOverlayState(overlays[j], "signed_in", detail.account || null, "Accesso completato.");
      } else if (detail.status === "signed_out") {
        setAccountOverlayState(overlays[j], "idle", null, "");
      }
    }
  });

  window.addEventListener("florame:native-auth-error", function () {
    var panels = document.querySelectorAll("[data-florame-ios-native-login]");
    for (var i = 0; i < panels.length; i += 1) {
      setIosNativePanelState(panels[i], "idle", null, "Accesso non completato. Riprova.");
    }
    var overlays = document.querySelectorAll("[data-florame-native-account-overlay]");
    for (var j = 0; j < overlays.length; j += 1) {
      setAccountOverlayState(overlays[j], "idle", null, "Accesso non completato. Riprova.");
    }
  });

  function setAccountOverlayState(overlay, state, account, message) {
    if (!overlay) return;
    var title = overlay.querySelector("[data-florame-native-account-title]");
    var subtitle = overlay.querySelector("[data-florame-native-account-subtitle]");
    var actions = overlay.querySelector("[data-florame-native-account-actions]");
    var accountBox = overlay.querySelector("[data-florame-native-account-box]");
    var status = overlay.querySelector("[data-florame-native-account-status]");
    var signedIn = state === "signed_in";
    var loading = state === "loading";
    overlay.__florameNativeAccountState = {
      state: state || "idle",
      account: account || null,
      message: message || ""
    };
    overlay.setAttribute("data-florame-native-account-state", state || "idle");
    if (title) title.textContent = signedIn
      ? (getNativeLanguage() === "en" ? "Hi " : "Ciao ") + accountDisplayName(account)
      : mnT("Accedi a Florame");
    if (subtitle) subtitle.textContent = signedIn
      ? mnT("Profilo Shopify collegato")
      : mnT("Usa il login social nativo dell'app.");
    if (actions) actions.style.display = signedIn ? "none" : "";
    if (status) status.textContent = message ? mnT(message) : "";

    var buttons = overlay.querySelectorAll("[data-florame-native-account-google], [data-florame-native-account-email]");
    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].disabled = loading || (buttons[i].hasAttribute("data-florame-native-account-google") && !nativeAuthAvailable("google.com"));
    }

    if (!accountBox) return;
    if (!signedIn) {
      accountBox.style.display = "none";
      accountBox.innerHTML = "";
      return;
    }
    var orders = Array.isArray(account && account.orders) ? account.orders.slice(0, 3) : [];
    accountBox.style.display = "";
    accountBox.innerHTML = [
      '<div class="florame-native-account-row"><span>Email</span><strong data-florame-native-account-email-value></strong></div>',
      '<div class="florame-native-account-row"><span>' + mnT("Cliente") + '</span><strong data-florame-native-account-customer-value></strong></div>',
      '<div class="florame-native-account-row"><span>' + mnT("Ordini recenti") + '</span><strong data-florame-native-account-orders-value></strong></div>',
      '<div class="florame-native-account-order-list" data-florame-native-account-order-list></div>',
      '<div class="florame-native-account-actions-secondary">',
      '<button type="button" data-florame-native-account-home>' + mnT("Home") + '</button>',
      '<button type="button" data-florame-native-account-logout>' + mnT("Esci") + '</button>',
      '</div>'
    ].join("");
    var emailValue = accountBox.querySelector("[data-florame-native-account-email-value]");
    var customerValue = accountBox.querySelector("[data-florame-native-account-customer-value]");
    var ordersValue = accountBox.querySelector("[data-florame-native-account-orders-value]");
    var orderList = accountBox.querySelector("[data-florame-native-account-order-list]");
    if (emailValue) emailValue.textContent = firstString([account && account.email, account && account.shopifyCustomer && account.shopifyCustomer.email, "-"]);
    if (customerValue) customerValue.textContent = accountShopifyLabel(account);
    if (ordersValue) ordersValue.textContent = String(Array.isArray(account && account.orders) ? account.orders.length : 0);
    if (orderList) {
      if (orders.length) {
        for (var j = 0; j < orders.length; j += 1) {
          var row = document.createElement("div");
          row.className = "florame-native-account-order";
          row.textContent = formatAccountOrder(orders[j]);
          orderList.appendChild(row);
        }
      } else {
        var empty = document.createElement("div");
        empty.className = "florame-native-account-order";
        empty.textContent = mnT("Nessun ordine recente");
        orderList.appendChild(empty);
      }
    }
    var home = accountBox.querySelector("[data-florame-native-account-home]");
    var logout = accountBox.querySelector("[data-florame-native-account-logout]");
    if (home) home.addEventListener("click", function () { window.location.href = "/pages/home"; });
    if (logout) {
      logout.addEventListener("click", function () {
        setAccountOverlayState(overlay, "loading", null, "Uscita...");
        signOutNativeAccount().then(function () {
          setAccountOverlayState(overlay, "idle", null, "");
        }).catch(function () {
          setAccountOverlayState(overlay, "signed_in", account, "Uscita non completata.");
        });
      });
    }
  }

  function showAccountLoginOverlay(fallbackUrl) {
    var existing = document.querySelector("[data-florame-native-account-overlay]");
    if (existing) {
      existing.__florameFallbackUrl = fallbackUrl || window.location.href;
      existing.style.display = "";
      setAccountOverlayState(existing, "loading", null, "Caricamento account...");
      bootstrapNativeAccount().then(function (account) {
        if (account && (account.uid || account.email)) {
          setAccountOverlayState(existing, "signed_in", account, "");
        } else {
          setAccountOverlayState(existing, "idle", null, "");
        }
      }).catch(function () {
        setAccountOverlayState(existing, "idle", null, "");
      });
      return;
    }
    injectStyle("florame-native-account-overlay-style", [
      ".florame-native-account-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:inherit;color:#1f1719;}",
      ".florame-native-account-backdrop{position:absolute;inset:0;background:rgba(31,23,25,.42);}",
      ".florame-native-account-dialog{position:relative;width:100%;max-width:520px;margin:0;background:#fff9fb;border:1px solid #f0cbd4;border-radius:18px 18px 0 0;padding:22px 18px 18px;box-sizing:border-box;box-shadow:0 -18px 48px rgba(31,23,25,.22);}",
      ".florame-native-account-dialog h2{font-size:22px;line-height:1.2;margin:0 0 8px;color:#1f1719;letter-spacing:0;}",
      ".florame-native-account-dialog p{font-size:14px;line-height:1.4;margin:0 0 16px;color:#5b4b50;}",
      ".florame-native-account-actions{display:grid;gap:10px;}",
      ".florame-native-account-actions button{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:48px;border:1px solid #d8c8cc;border-radius:8px;background:#fff;color:#111;text-decoration:none;font-size:15px;font-weight:700;line-height:1.2;box-sizing:border-box;}",
      ".florame-native-account-actions button:disabled{opacity:.55;}",
      ".florame-native-account-secondary{background:transparent!important;color:#8a5965!important;border-color:transparent!important;}",
      ".florame-native-account-status{min-height:18px;font-size:13px;line-height:1.35;color:#704a55;margin:12px 0 0;}",
      ".florame-native-account-box{margin-top:14px;border-top:1px solid #f0cbd4;padding-top:12px;}",
      ".florame-native-account-row{display:flex;justify-content:space-between;gap:12px;font-size:14px;line-height:1.35;padding:6px 0;color:#5b4b50;}",
      ".florame-native-account-row strong{color:#1f1719;text-align:right;font-weight:700;overflow-wrap:anywhere;}",
      ".florame-native-account-order-list{display:grid;gap:6px;margin:8px 0 0;}",
      ".florame-native-account-order{font-size:13px;line-height:1.35;color:#5b4b50;background:#fff;border:1px solid #f0dbe1;border-radius:8px;padding:8px 10px;}",
      ".florame-native-account-actions-secondary{display:flex;gap:10px;margin-top:12px;}",
      ".florame-native-account-actions-secondary button{min-height:40px;border:1px solid #d8c8cc;border-radius:8px;background:#fff;color:#1f1719;font-weight:700;padding:0 14px;}"
    ].join(""));

    var overlay = document.createElement("div");
    overlay.className = "florame-native-account-overlay";
    overlay.setAttribute("data-florame-native-account-overlay", "true");
    overlay.__florameFallbackUrl = fallbackUrl || window.location.href;
    overlay.innerHTML = [
      '<div class="florame-native-account-backdrop" data-florame-native-account-close></div>',
      '<section class="florame-native-account-dialog" role="dialog" aria-modal="true">',
      '<h2 data-florame-native-account-title>' + mnT("Accedi a Florame") + '</h2>',
      '<p data-florame-native-account-subtitle>' + mnT("Usa il login social nativo dell'app.") + '</p>',
      '<div class="florame-native-account-actions" data-florame-native-account-actions>',
      '<button type="button" data-florame-native-account-google><span class="florame-ios-native-mark">G</span><span>' + mnT("Continua con Google") + '</span></button>',
      '<button type="button" class="florame-native-account-secondary" data-florame-native-account-email>' + mnT("Usa email") + '</button>',
      '<button type="button" class="florame-native-account-secondary" data-florame-native-account-close>' + mnT("Chiudi") + '</button>',
      '</div>',
      '<div class="florame-native-account-box" data-florame-native-account-box style="display:none"></div>',
      '<div class="florame-native-account-status" data-florame-native-account-status aria-live="polite"></div>',
      '</section>'
    ].join("");
    document.body.appendChild(overlay);

    var status = overlay.querySelector("[data-florame-native-account-status]");
    var google = overlay.querySelector("[data-florame-native-account-google]");
    var email = overlay.querySelector("[data-florame-native-account-email]");
    var closeNodes = overlay.querySelectorAll("[data-florame-native-account-close]");
    var close = function () { overlay.style.display = "none"; };
    for (var i = 0; i < closeNodes.length; i += 1) closeNodes[i].addEventListener("click", close);
    if (google) {
      google.disabled = !nativeAuthAvailable("google.com");
      google.addEventListener("click", function () {
        google.disabled = true;
        setAccountOverlayState(overlay, "loading", null, "Apertura Google...");
        startNativeSocialLogin("google.com").then(function (account) {
          if (account) {
            setAccountOverlayState(overlay, "signed_in", account, "Accesso completato.");
          } else {
            setAccountOverlayState(overlay, "loading", null, "Completa il login nella finestra sicura.");
          }
        }).catch(function (err) {
          emit("florame:native-auth-error", { error: err && err.message ? err.message : String(err), provider: "google.com" });
          google.disabled = !nativeAuthAvailable("google.com");
          setAccountOverlayState(overlay, "idle", null, err && err.message === "Google sign-in did not open"
            ? "Google non si e aperto. Riprova."
            : "Accesso non completato. Riprova.");
        });
      });
    }
    if (email) {
      email.addEventListener("click", function () {
        if (status) status.textContent = mnT("Completa il login nella finestra sicura.");
        startShopifyAccountBrowserLogin(overlay.__florameFallbackUrl).catch(function () {
          window.location.href = getCustomerAccountBrowserUrl(overlay.__florameFallbackUrl);
        });
      });
    }
    if (status && !nativeAuthAvailable("google.com")) {
      status.textContent = mnT("Login nativo non disponibile in questa build.");
    }
    setAccountOverlayState(overlay, "loading", null, "Caricamento account...");
    bootstrapNativeAccount().then(function (account) {
      if (account && (account.uid || account.email)) {
        setAccountOverlayState(overlay, "signed_in", account, "");
      } else {
        setAccountOverlayState(overlay, "idle", null, "");
      }
    }).catch(function () {
      setAccountOverlayState(overlay, "idle", null, "");
    });
  }

  function setupNativeSocialLogin() {
    if ((getPlatform() !== "ios" && getPlatform() !== "android") || !isAccountLoginPage()) return;
    injectStyle("florame-ios-social-login-style", [
      ".florame-ios-native-login{margin:0 auto 22px auto;padding:22px 18px;border:1px solid #f0cbd4;background:#fff9fb;color:#1f1719;box-sizing:border-box;max-width:520px;}",
      ".florame-ios-native-logo{font-weight:800;font-size:12px;letter-spacing:0;text-transform:uppercase;color:#ff4d75;margin:0 0 10px 0;}",
      ".florame-ios-native-login h2{font-size:22px;line-height:1.2;margin:0 0 8px 0;letter-spacing:0;color:#1f1719;}",
      ".florame-ios-native-login p{font-size:14px;line-height:1.4;margin:0 0 16px 0;color:#5b4b50;}",
      ".florame-ios-native-buttons{display:grid;gap:10px;margin:0 0 12px 0;}",
      ".florame-ios-native-buttons button{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:48px;border:1px solid #d8c8cc;border-radius:8px;background:#fff;color:#111;text-decoration:none;font-size:15px;font-weight:700;line-height:1.2;box-sizing:border-box;}",
      ".florame-ios-native-buttons button:disabled{opacity:.55;}",
      ".florame-ios-native-buttons button:active{background:#f6f6f6;}",
      ".florame-ios-native-mark{min-width:34px;font-size:12px;font-weight:800;letter-spacing:0;text-transform:uppercase;text-align:center;}",
      ".florame-ios-native-status{min-height:18px;font-size:13px;line-height:1.35;color:#704a55;margin-top:8px;}",
      ".florame-ios-native-account{margin-top:14px;border-top:1px solid #f0cbd4;padding-top:12px;}",
      ".florame-ios-native-account-row{display:flex;justify-content:space-between;gap:12px;font-size:14px;line-height:1.35;padding:6px 0;color:#5b4b50;}",
      ".florame-ios-native-account-row strong{color:#1f1719;text-align:right;font-weight:700;overflow-wrap:anywhere;}",
      ".florame-ios-native-actions{display:flex;gap:10px;margin-top:12px;}",
      ".florame-ios-native-actions button,.florame-ios-native-email{min-height:40px;border:1px solid #d8c8cc;border-radius:8px;background:#fff;color:#1f1719;font-weight:700;padding:0 14px;}",
      ".florame-ios-native-email{margin-top:4px;background:transparent;border-color:transparent;color:#8a5965;}",
      "[data-florame-ios-hidden='true']{display:none!important;height:0!important;margin:0!important;padding:0!important;}"
    ].join(""));

    var apply = function () {
      hideOxiSocialIframe();
      ensureIosNativeLoginPanel();
    };
    apply();
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", apply);
    }
    var observer = new MutationObserver(apply);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(apply, 400);
    setTimeout(apply, 1200);
    setTimeout(apply, 2500);
  }

  function navigateFromNotification(url) {
    if (!url) return;
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.hostname === "florame.ai" || parsed.hostname.endsWith(".florame.ai")) {
        window.location.href = parsed.href;
        return;
      }
      openExternal(parsed.href).catch(function () {});
    } catch (_) {}
  }

  function setupNotificationListeners() {
    var FirebaseMessaging = getPlugin("FirebaseMessaging");
    if (!FirebaseMessaging || typeof FirebaseMessaging.addListener !== "function") return;
    FirebaseMessaging.addListener("tokenReceived", function (event) {
      if (event && event.token) {
        registerPushToken(event.token, { source: "tokenReceived" }).catch(function (err) {
          emit("florame:native-push-error", { error: err.message || String(err), source: "tokenReceived" });
        });
      }
    }).catch(function () {});
    FirebaseMessaging.addListener("notificationReceived", function (event) {
      emit("florame:native-notification", { type: "received", notification: event && event.notification ? event.notification : event });
    }).catch(function () {});
    FirebaseMessaging.addListener("notificationActionPerformed", function (event) {
      emit("florame:native-notification", { type: "action", notification: event && event.notification ? event.notification : event });
      navigateFromNotification(extractNotificationUrl(event));
    }).catch(function () {});
  }

  function setupCustomerAccountLinkInterception() {
    if (!isNativePlatform() || document.__florameCustomerAccountLinks) return;
    document.__florameCustomerAccountLinks = true;
    document.addEventListener("click", function (event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target;
      var link = target && target.closest ? target.closest("a[href]") : null;
      if (!link) return;
      var href = link.getAttribute("href") || "";
      if (!isCustomerAccountUrl(href)) return;
      event.preventDefault();
      showAccountLoginOverlay(href);
      var task = Promise.resolve(null);
      task.catch(function (err) {
        emit("florame:native-auth-error", {
          error: err && err.message ? err.message : String(err),
          provider: "shopify_customer_account"
        });
      });
    }, true);
  }

  function setupAppListeners() {
    var App = getPlugin("App");
    if (!App || typeof App.addListener !== "function") return;
    App.addListener("appUrlOpen", function (event) {
      if (!event || !event.url) return;
      if (isCustomerAccountCallbackUrl(event.url)) {
        handleCustomerAccountCallback(event.url).catch(function (err) {
          emit("florame:native-auth-error", {
            error: err && err.message ? err.message : String(err),
            provider: "shopify_customer_account"
          });
        });
        return;
      }
      navigateFromNotification(event.url);
    }).catch(function () {});
  }

  async function refreshTokenIfAllowed() {
    try {
      await requestNotifications({ prompt: false, source: "auto_refresh" });
    } catch (_) {}
  }

  function requestPushAfterGesture() {
    var run = function () {
      prefGet(PUSH_PROMPT_KEY)
        .then(function (done) {
          if (done) return null;
          return prefSet(PUSH_PROMPT_KEY, "1").then(function () {
            return requestNotifications({ prompt: true, source: "first_interaction" });
          });
        })
        .catch(function (err) {
          emit("florame:native-push-error", { error: err.message || String(err), source: "first_interaction" });
        });
    };
    window.addEventListener("click", run, { once: true, passive: true });
    window.addEventListener("touchend", run, { once: true, passive: true });
  }

  if (!isNativePlatform()) {
    window.FlorameNative = {
      isNative: false,
      platform: "web",
      requestLocation: function () { return Promise.reject(new Error("Native app not available")); },
      requestNotifications: function () { return Promise.reject(new Error("Native app not available")); },
      registerPushToken: function () { return Promise.reject(new Error("Native app not available")); },
      openExternal: openExternal
    };
    window.FlorameNativeAuth = {
      isAvailable: false,
      signInWithGoogle: function () { return Promise.reject(new Error("Native app not available")); },
      signInWithApple: function () { return Promise.reject(new Error("Native app not available")); },
      getAccount: function () { return Promise.resolve(null); },
      getIdToken: function () { return Promise.resolve(""); },
      getCustomerAccessToken: function () { return Promise.resolve(""); },
      signOut: function () { return Promise.resolve(); }
    };
    return;
  }

  window.FlorameNative = {
    isNative: true,
    platform: getPlatform(),
    requestLocation: requestLocation,
    requestNotifications: requestNotifications,
    registerPushToken: registerPushToken,
    openExternal: openExternal
  };

  window.FlorameNativeAuth = {
    isAvailable: nativeAuthAvailable(),
    signInWithGoogle: function () { return startNativeSocialLogin("google.com"); },
    signInWithApple: function () { return startNativeSocialLogin("apple.com"); },
    getAccount: bootstrapNativeAccount,
    getIdToken: nativeAuthGetIdToken,
    getCustomerAccessToken: function () {
      return loadCustomerAccountTokens({ refresh: true }).then(function (tokens) {
        return tokens && tokens.accessToken ? tokens.accessToken : "";
      });
    },
    signOut: signOutNativeAccount
  };

  patchGeolocation();
  setupNativeSocialLogin();
  setupCustomerAccountLinkInterception();
  setupNotificationListeners();
  setupAppListeners();
  ensureNotificationChannel().catch(function () {});
  setTimeout(refreshTokenIfAllowed, 800);
  requestPushAfterGesture();
  emit("florame:native-ready", { platform: getPlatform() });
})();
